<template>
    <div class="receipt-action-buttons">
        <template v-if="paymentFor == PaymentFor.Order">
            <SendOrderPaymentReceiptButton
                v-if="!isPayLater"
                ref="sendOrderPaymentReceiptButton"
                :emailRecipient="emailRecipient"
                :orderId="orderId!"
                :locationId="locationId"
                :onSendReceiptSuccess="onSendReceiptSuccess"
            />
            <PrintOrderPaymentReceiptButton
                v-if="isPrintButtonAvailable"
                :orderId="orderId!"
                :locationId="locationId"
                :hidden="hidePrintButton"
                :hideIfNotAvailable="true"
                :onPrintSuccess="onPrintSuccess"
            />
        </template>

        <template v-if="paymentFor == PaymentFor.Bill">
            <SendBillPaymentReceiptButton
                v-if="!isPayLater"
                ref="sendBillPaymentReceiptButton"
                :emailRecipient="emailRecipient"
                :paymentId="paymentId!"
                :locationId="locationId"
                :onSendReceiptSuccess="onSendReceiptSuccess"
            />
            <PrintBillPaymentReceiptButton
                v-if="isPrintButtonAvailable"
                :paymentId="paymentId!"
                :locationId="locationId"
                :hidden="hidePrintButton"
                :hideIfNotAvailable="true"
                :onPrintSuccess="onPrintSuccess"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import { PaymentFor } from "@/data/model/Enums";
    import { computed, ref } from "vue";

    import PrintBillPaymentReceiptButton from "@/components/payment/PrintBillPaymentReceiptButton.vue";
    import PrintOrderPaymentReceiptButton from "@/components/payment/PrintOrderPaymentReceiptButton.vue";
    import SendBillPaymentReceiptButton from "@/components/payment/SendBillPaymentReceiptButton.vue";
    import SendOrderPaymentReceiptButton from "@/components/payment/SendOrderPaymentReceiptButton.vue";

    const props = defineProps<{
        paymentFor: PaymentFor;
        emailRecipient: string | undefined;
        locationId: string;
        orderId: string | undefined;
        paymentId: string | undefined;
        userIsWaiter: boolean;
        isPayLater: boolean;
        onSendReceiptSuccess: () => void;
        onPrintSuccess: () => void;
        hidePrintButtonOnEmailInputStarted: boolean;
    }>();

    // todo: print is not available if user is not waiter or if print is not enabled in the location or if payment was pay later - hide button

    const sendOrderPaymentReceiptButton = ref<InstanceType<typeof SendOrderPaymentReceiptButton> | null>(null);
    const sendBillPaymentReceiptButton = ref<InstanceType<typeof SendBillPaymentReceiptButton> | null>(null);
    const isEmailInputStarted = computed(() => props.emailRecipient != null && props.emailRecipient.length > 0);
    const hidePrintButton = computed(() => props.hidePrintButtonOnEmailInputStarted && isEmailInputStarted.value);
    const isPrintButtonAvailable = computed(() => props.userIsWaiter && !props.isPayLater);

    function sendReceipt() {
        if (props.paymentFor == PaymentFor.Order) {
            sendOrderPaymentReceiptButton.value?.sendReceipt();
        }
        if (props.paymentFor == PaymentFor.Bill) {
            sendBillPaymentReceiptButton.value?.sendReceipt();
        }
    }

    defineExpose({
        sendReceipt,
    });
</script>
